import {
    MultilingualFieldRestDto,
    ProductCategoryCustomerNameRestDto
} from "@/api/pharma-cpc-product-category-mgmt/models";
import {MultilingualFieldRestDtoModel} from "@/models/api/pharma-order-enum/MultilingualFieldRestDtoModel";

export class ProductCategoryCustomerNameRestDtoModel implements ProductCategoryCustomerNameRestDto {

    name: MultilingualFieldRestDto;

    constructor(name: MultilingualFieldRestDto) {
        this.name = name;
    }

    public static createWithDefaults(): ProductCategoryCustomerNameRestDtoModel {
        return new this(MultilingualFieldRestDtoModel.createWithDefaults());
    }
}
